import React from 'react';
import { Box, Typography } from '@mui/material';
import { CarIcon } from './Icons';
import AnimatedCircle from './AnimatedCircle';

const EmptyStateContainer = ({ 
  description = "There are no vehicles matching your current filters.",
  sx = {},
  ...props 
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        py: { xs: 4, sm: 6 },
        px: { xs: 2, sm: 3 },
        ...sx,
      }}
      {...props}
    >
      <AnimatedCircle sx={{ 
        my: { xs: 3, sm: 4 },
        width: { xs: 100, sm: 120 },
        height: { xs: 100, sm: 120 }
      }}>
        <CarIcon sx={{ 
          fontSize: { xs: 40, sm: 48 }, 
          color: 'primary.contrastText',
          filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.2))'
        }} />
      </AnimatedCircle>
      <Typography 
        variant="body1" 
        sx={{ 
          color: 'text.secondary',
          maxWidth: '400px',
          textAlign: 'center',
          lineHeight: 1.6,
        }}
      >
        {description}
      </Typography>
    </Box>
  );
};

export default EmptyStateContainer;
